import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    transactions: [],
}
const mutations = {
    nothing(){},

    transaction_list(state , transactions){
        Vue.set(state, 'transactions', transactions);
        Vue.set(state, 'transactions', [...transactions]);
    },

    add_transaction(state, transaction){
        Vue.set(state, 'transactions', [...transaction]);
    },

    edit_transaction(state, payload){
        const item = state.transactions.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_transaction(state, id){
        const itemIndex = state.transactions.findIndex(item => item.id === id);
        state.transactions.splice(itemIndex , 1);
    },

}
const actions = {
    getTransactions({ dispatch, commit }){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/transactions`, method: 'GET' })
            .then(res => {
                commit('transaction_list', res.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    getTransactionInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/transaction/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    addTransaction({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/storeTransaction`, data: payload, method: 'POST' })
            .then(res => {
                commit('add_transaction', payload)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },
}
const modules = {

}
const getters = {
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
